import axios from "@/utils/axiosUtils";

//method=common&invoiceId=132&bookingType=hotel&paymentGatewayId=STRIPE&currencyCode=HKD
function payByCredit(invoiceId, productType, bookingRQ) {
  let url =
    "/api/v3/accounting/receipts/initialization?method=CREDIT&invoiceId=" +
    invoiceId +
    "&bookingType=" +
    productType +
    "&paymentGatewayId=";
  return axios.post(url, bookingRQ, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

function saveNecessaryInfo(invoiceId, productType, bookingRQ) {
  let url =
    "/api/v3/accounting/receipts/necessary-info?invoiceId=" +
    invoiceId +
    "&bookingType=" +
    productType;
  return axios.post(url, bookingRQ, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

function commonInitiatePayment(
  invoiceId,
  bookingType,
  paymentGatewayId,
  bookRQ,
  currencyCode,
  successUrl,
  cancelUrl
) {
  const params = new URLSearchParams();
  params.append("method", "common");
  params.append("invoiceId", invoiceId);
  params.append("bookingType", bookingType);
  params.append("paymentGatewayId", paymentGatewayId);
  params.append("currencyCode", currencyCode);
  params.append("successUrl", successUrl); // 自动处理特殊字符
  params.append("cancelUrl", cancelUrl);

  const url = `/api/v3/accounting/receipts/initialization?${params.toString()}`;
  return axios.post(url, bookRQ, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

function getPaymentGateway() {
  let url = "/api//v3/content/website/payment-gateway";
  return axios.get(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export default {
  payByCredit,
  saveNecessaryInfo,
  commonInitiatePayment,
  getPaymentGateway,
};
